import React, { FC, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ReactJson from 'react-json-view';
import moment from 'moment';

import { QueryTable, TableColumn } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { HistoryItem } from '@app/api/admin';
import { Dialog, FieldView, Txt } from '@app/components/common';
import { USER_DATE_TIME_FORMAT } from '@app/utils';

import Columns from './columns';

const HistoryTable: FC = () => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState<HistoryItem>();
  const [fetchData] = useFetchData({
    method: api.admin.getHistory
  });

  const onOpen = async (item: HistoryItem) => {
    setCurrentItem(item);
    setOpen(true);
  };

  return (
    <>
      <QueryTable
        title="История изменений"
        columns={Columns as TableColumn<any>[]}
        fetchData={fetchData}
        onRowClick={onOpen}
      />
      <Dialog 
        title={currentItem?.id}
        open={open} onClose={() => setOpen(false)}
      >
      {currentItem && <Box display="flex" justifyContent="space-between">
        <Box w='100%'>
          <Box display="flex" alignItems="center" w='100%'>
            <Flex gap={4} justifyContent='space-between' flex={1}>
              <Txt color='brand.500'>{currentItem.url_rule}</Txt>
            </Flex>
          </Box>
          <Box display="flex" flexDirection='column' gap={0} w='100%'>
            <FieldView title="Пользователь" value={currentItem.user.full_name} direction='row' fullWidth />

            <FieldView title="Дата/время" value={moment(currentItem.create_dt).format(USER_DATE_TIME_FORMAT)} direction='row' fullWidth />
 
          </Box>
          <Box display="flex" pt={2} flexDirection="column" gap={4} w='100%'>
            <Txt color='gray.500'>Параметры</Txt>
            <Box overflow="auto" maxHeight={400} border='1px solid' borderColor='gray.200'>
              {currentItem.params && <ReactJson src={currentItem.params} name={false} collapsed={2} />}
              {!currentItem.params && <Txt textAlign="center" color='gray.500'>Пусто</Txt>}
            </Box>
          </Box>
          <Box display="flex" pt={3} flexDirection="column" gap={4} w='100%'>
            <Txt color='gray.500'>Payload</Txt>
            <Box overflow="auto" maxHeight={400}>
              {currentItem.json && <ReactJson src={currentItem.json} name={false} collapsed={2} />}
              {!currentItem.json && <Txt textAlign='center' color='gray.500'>Пусто</Txt>}
            </Box>
          </Box>
        </Box>
      </Box>}
    </Dialog>
    </>
  );
};

export default HistoryTable;
